<template>
  <div class="index_container my">
    <div class="my_main">我的</div>
    <footerNavigation></footerNavigation>
  </div>
</template>
<script>
// import { ElInput, ElIcon, ElCheckbox } from "element-plus";
// import { Search } from "@element-plus/icons";
// import postItem from "./postItem.vue";
import footerNavigation from "@/components/unit/footerNavigation.vue";
export default {
  name: "index",
  components: {
    // ElInput,
    // Search,
    // ElIcon,
    // ElCheckbox,
    // postItem,
    footerNavigation,
  },
  data() {
    return {
      search: "",
      data: [],
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style >
.index_container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.my_main {
  flex: 1 0 0;
  overflow: auto;
}
</style>